import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { FiUser, FiSettings, FiLogOut } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext'; // 1. IMPORT THE AUTH HOOK

const DropdownMenu = styled.div`
  /* ... No changes needed to your styled components ... */
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  min-width: 220px;
  z-index: 1000;
  overflow: hidden;
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-8px)')};
  transition: ${({ theme }) => theme.transitions.medium};
  border: 1px solid ${({ theme }) => theme.colors.lightBorder};
`;

const DropdownHeader = styled.div`
  /* ... No changes needed ... */
  padding: ${({ theme }) => theme.spacing.md};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightBorder};
  background-color: ${({ theme }) => theme.colors.background};
  
  h4 {
    margin: 0 0 ${({ theme }) => theme.spacing.xxs} 0;
    font-size: 0.95rem;
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
  p {
    font-size: 0.8rem;
    color: ${({ theme }) => theme.colors.textMuted};
    margin: 0;
  }
`;

const DropdownItemStyled = styled(Link)`
  /* ... No changes needed ... */
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.md}`};
  color: ${({ theme }) => theme.colors.textSecondary};
  // ... rest of your styles
`;


const ProfileDropdown = ({ isOpen }) => {
  const navigate = useNavigate();
  // 2. GET THE ADMIN INFO AND LOGOUT FUNCTION FROM THE CONTEXT
  const { admin, logout } = useAuth(); 

  const handleLogout = () => {
    // 3. CALL THE LOGOUT FUNCTION FROM THE CONTEXT
    logout(); 
    // This will clear localStorage and update the global state.
    // The navigate() call will then redirect the user.
    navigate('/admin/login'); // Changed to '/admin/login' for consistency
  };

  // Use the admin object from the context to display info
  const displayName = admin?.username ? admin.username.charAt(0).toUpperCase() + admin.username.slice(1) : 'Admin';

  return (
    <DropdownMenu isOpen={isOpen}>
      <DropdownHeader>
        <h4>{displayName}</h4>
        <p>Administrator Role</p>
      </DropdownHeader>
      
      {/* <DropdownItemStyled to="/dash/settings"> 
        <FiSettings /> Account Settings
      </DropdownItemStyled> */}

      {/* The `as="button"` is a great pattern here! */}
      <DropdownItemStyled as="button" onClick={handleLogout} className="logout">
        <FiLogOut /> Logout
      </DropdownItemStyled>
    </DropdownMenu>
  );
};

export default ProfileDropdown;